/*
* Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
*
* Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
* the License. A copy of the License is located at
*
*     http://aws.amazon.com/apache2.0/
*
* or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
* CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
* and limitations under the License.
*/

<template>
  <div class="body" style="text-align:left;padding:10px">
    <div class="row clearfix">
      <div class="form-group col-md-12" v-for="field in fields" v-bind:key="field.name">
        <div v-if="field.type === 'string'">
          <label :for="'input-'+field.label" class="col-form-label">{{field.label || field.name}}</label>
          <input v-model="user[field.name]" class="form-control" :id="'input-'+field.label"
                 :placeholder="field.label" disabled>
        </div>
        <div class="lineBreak" v-if="field.type === 'lineBreak'"></div>
      </div>
    </div>
    <div class="row">
      <div class="form-group col">
        <!-- <button class="btn btn-outline-primary" v-on:click="save" style="position: relative;float: right">Save</button> -->
      </div>
    </div>
  </div>
</template>

<script>
  import { Auth } from 'aws-amplify'

  export default {
    name: 'ProfileForm',
    props: ['fields','user'],
    data() {
      return {
      }
    },
    async mounted() {
      if (this.user == null) {
        const currentUser = await Auth.currentAuthenticatedUser()
        this.user = {
          ...currentUser.attributes
        }
      } else {
        const attrs = this.user.attributes
        this.user = {
          ...attrs
        }
      }

      console.log('=== user ===')
      console.log(this.user)
    },
    methods: {
      async save() {
        const cognitoUser = await Auth.currentAuthenticatedUser()
        if (!this.user || !cognitoUser) {
          return
        }
        Auth.updateUserAttributes(cognitoUser, this.user).then((res) => {
          console.log(res)
        })
          .catch(e => console.log(e));
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ProfileForm.vue